var render = function render(){var _vm=this,_c=_vm._self._c;return _c('m-main-layout',[_c('div',{staticClass:"page-content-main"},[_vm._v(" 21 ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }